import { render, staticRenderFns } from "./ShortSection.vue?vue&type=template&id=4a5f9dfa&scoped=true&"
import script from "./ShortSection.vue?vue&type=script&lang=js&"
export * from "./ShortSection.vue?vue&type=script&lang=js&"
import style0 from "./ShortSection.vue?vue&type=style&index=0&id=4a5f9dfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f9dfa",
  null
  
)

export default component.exports